/**
 * @file requiredMark.tsx
 * @description Premium required-field indicator. A small, accent-colored
 * asterisk shown beside a field label to signal that the field is mandatory.
 * Kept as a shared component so every input renders an identical, on-brand mark.
 */

import React from 'react';
import { Text, StyleSheet, Platform } from 'react-native';
import { useTheme } from '../context/themeContext';

const RequiredMark: React.FC = () => {
  const { theme } = useTheme();
  const { colors } = theme;

  return (
    <Text
      style={[styles.mark, { color: colors.danger }]}
      accessibilityLabel="required"
      accessibilityElementsHidden={false}
    >
      ✱
    </Text>
  );
};

const styles = StyleSheet.create({
  mark: {
    marginLeft: 4,
    fontSize: 11,
    fontWeight: '900',
    // Nudge up so it reads as a crisp superscript beside the uppercase label.
    lineHeight: 12,
    ...(Platform.OS === 'web'
      ? ({ textShadow: '0 1px 3px rgba(220,38,38,0.30)' } as any)
      : {}),
  },
});

export default RequiredMark;
